<template>
    <NuxtLink
        v-if="url && spanContent"
        :to="url"
        target="_blank"
    >
        <span
            class="whitespace-nowrap"
            v-html="spanContent"
        />
    </NuxtLink>
</template>

<script lang="ts" setup>
const props = defineProps<{
    html: string
}>()

// Use a DOM parser to extract the information
const parser = new DOMParser()
const doc = parser.parseFromString(props.html, "text/html")

// Extract the href attribute value (URL)
const url = doc.querySelector("a")?.getAttribute("href")

// Extract the content inside the <span> tag
const spanContent = doc
    .querySelector("span")
    ?.textContent?.replace("🡨", "<i class='pi pi-arrow-left text-sm'></i>")

// console.log({ url, spanContent })
</script>

<style scoped></style>
